// extracted by mini-css-extract-plugin
export var carrierNotice = "_ke-5";
export var carrierNoticePlaceholder = "_ke-6";
export var deliveryRow = "_ke-c";
export var fixedHeight = "_ke-4";
export var freightLogo = "_ke-b";
export var fullWidth = "_ke-3";
export var priceColumn = "_ke-7";
export var radioSelected = "_ke-9";
export var radioUnselected = "_ke-8";
export var selectedOption = "_ke-2";
export var selectedOptionContainer = "_ke-1";
export var selection = "_ke-0";
export var tallSkeletonText = "_ke-a";